import { render } from "./DuplicateFormModal.vue?vue&type=template&id=35751c3e"
import script from "./DuplicateFormModal.vue?vue&type=script&lang=js"
export * from "./DuplicateFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__